<template>
  <div v-if="form">
    <vxe-modal
      v-model="dialogVisible"
      title="万金油余额"
      width="600px"
      :before-close="close"
      resize
    >
      <div style="padding-bottom:15px;">
        <el-button type="primary" style="width:48%;"
          >总余额(元):{{ form.money }}
        </el-button>
        <el-button type="primary" style="width:48%;"
          >总待领取金额(元):{{ form.outstandingBalance }}
        </el-button>
      </div>
      <vxe-table border height="250" :data="form.list" :loading="loading">
        <vxe-table-column field="categoryName" title="品类名称" />
        <vxe-table-column field="mcId" title="实际承运人卡账户id" />
        <vxe-table-column field="amount" title="实际承运人卡余额(元)" />
        <vxe-table-column
          field="outstandingBalance"
          title="实际承运人卡待领取金额(元)"
        />
      </vxe-table>
    </vxe-modal>
  </div>
</template>

<script>
import { getBackMoney } from "@/api/userOil";
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        outstandingBalance: "",
        money: "",
        list: []
      }
    };
  },
  created() {},
  methods: {
    show(item) {
      this.form = {
        name: "",
        balance: "",
        waitMoney: ""
      };
      this.loading = true;
      this.dialogVisible = true;
      return getBackMoney({
        userName: item.phone,
        mcId: "",
        cardNo: ""
      })
        .then(response => {
          let data = response.data;
          this.form = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped lang="scss"></style>
